import TableModule from './TableModule';

export default TableModule;
